import { ArchiveIcon } from '@ui/icons';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { issuesActions } from '@sonar-software/sonar-issues';
import { useAction } from '@hooks';
import React, { useCallback } from 'react';
export const ArchiveIssueButton = ({ sonarObjectId }) => {
    const archiveOrSnoozeIssue = useAction(issuesActions.requestPostIssuesByIdVisibility);
    const handleArchiveClick = useCallback((e) => {
        e.stopPropagation();
        archiveOrSnoozeIssue({
            archive: true,
            sonarObjectId
        });
    }, [archiveOrSnoozeIssue, sonarObjectId]);
    return (React.createElement(Button, { icon: React.createElement(ArchiveIcon, null), id: `archive-issue-${sonarObjectId}`, onClick: handleArchiveClick, type: 'default' }, COPY_SPECIFIC.ARCHIVE));
};
